// extracted by mini-css-extract-plugin
export default {"Discount":"Discount_Discount__HmCdt","Desc":"Discount_Desc__pg+mg","DiscountBtn":"Discount_DiscountBtn__c9PIw","DiscountImg":"Discount_DiscountImg__GO3HC"};